import * as React from 'react';
import { CurrentLocationIdType, CurrentLocationRouteStateContext } from '../contexts';

/**
 * Use the current client from the combined contexts
 *
 * @returns The current client
 */
export function useCurrentLocationState(): CurrentLocationIdType | undefined {
    const currentLocationFromContext = React.useContext(CurrentLocationRouteStateContext);
    return currentLocationFromContext ?? undefined;
}
